<footer class="w-full h-full bg-main-black md:px-10 md:pt-10 pb-5 px-4 pt-8 border-t border-white">
  <div class="flex md:flex-row flex-col items-start justify-between gap-10">
    <div>
      <a><img src="logo.png" alt="Yarrow Logo" class="h-10" /></a>
    </div>
    <div class="flex md:flex-row flex-col items-start justify-start gap-10 text-white">
      <div class="flex flex-col items-start justify-start gap-4">
        <h2
          i18n="footer|More Info heading@@footer.moreInfo"
          class="text-lg font-semibold text-white tracking-wide"
        >
          More Info
        </h2>
        <ul class="flex flex-col items-start justify-start gap-2">
          <li
            class="text-sm font-thin cursor-pointer hover:text-main-blue-light transition-all duration-300 hover:underline"
          >
            <a i18n="footer|Terms and conditions link@@footer.terms" href="/">Terms & Conditions</a>
          </li>
          <li
            class="text-sm font-thin cursor-pointer hover:text-main-blue-light transition-all duration-300 hover:underline"
          >
            <a i18n="footer|Privacy and policy link@@footer.privacy" href="/">Privacy & Policy</a>
          </li>
        </ul>
      </div>
      <div class="flex flex-col items-start justify-start gap-4">
        <h2
          i18n="footer|Contact us heading@@footer.contactUs"
          class="text-lg font-semibold text-white tracking-wide"
        >
          Contact Us
        </h2>
        <ul class="flex flex-col items-start justify-start gap-2">
          <li
            class="gap-2 text-sm font-thin cursor-pointer hover:text-main-blue-light transition-all duration-300 hover:underline"
          >
            <a class="flex items-center justify-start gap-2" href="/"
              ><img src="mobile.svg" alt="Mobile" class="w-4 h-4" /> +66 86-870-1818</a
            >
          </li>
          <li
            class="gap-2 text-sm font-thin cursor-pointer hover:text-main-blue-light transition-all duration-300 hover:underline"
          >
            <a class="flex items-center justify-start gap-2" href="/"
              ><img src="mail.svg" alt="Email" class="w-4 h-4" /> info@yarrowpass.com</a
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="flex items-start justify-start 4 mt-10">
    <p
      i18n="footer|Copyright text@@footer.copyright"
      class="text-sm font-thin text-white tracking-wide"
    >
      &copy; {{ year }} Yarrow Pass. All rights reserved.
    </p>
  </div>
</footer>
